<template>
  <div class='YHead'>
    <img class="icon" :src="userInfo.icon ? userInfo.icon : 'https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/ODC/odc-web/default_img.png'" alt="">
    <div class="info">
      <div class="title">申请人</div>
      <div class="name">{{userInfo.username}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YHead',

  data () {
    return {
      userInfo: JSON.parse(sessionStorage.getItem('User'))
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {}
  }
}
</script>

<style lang='stylus' scoped>
  .YHead
    display flex
    padding 20px 0 30px 0
    border-bottom 1px solid #dbe3ef
    .icon
      width 100px
      height 100px
      border-radius 50%
    .info
      margin-left 20px
      display flex
      flex-direction column
      justify-content center
      .title
        font-size 22px
        line-height 22px
      .name
        margin-top 10px
        font-size 22px
        line-height 22px
</style>
